import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getSubmitRequestsTable } from "../../Requests/applyOption";
import { IApplyOptionsCommonSearchParam } from "src/Interfaces/applyOption";

interface IProps {
  searchParams: IApplyOptionsCommonSearchParam;
  refreshFlag?: boolean;
}

const SubmitRequestsTable = ({ searchParams, refreshFlag }: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, any>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getSubmitRequestsTable}
      pagesize={200}
      withSort
      searchParameters={searchParams}
    />
  );
};

export default SubmitRequestsTable;
